import classNames from 'classnames';

import BaseSideMenuItem from './base-side-menu-item';

import type { NavItem } from 'components/shared/side-menu/nav-config';

interface BaseCollapsedSectionProps {
  title?: string;
  visibleItems: NavItem[];
  isCollapsed: boolean;
  isItemActive: (item: NavItem) => boolean;
  renderLink: (props: Record<string, unknown>) => React.ReactNode;
  getNotification?: (item: NavItem) => boolean;
  className?: string;
}

const BaseCollapsedSection = ({
  title,
  visibleItems,
  isCollapsed,
  isItemActive,
  renderLink,
  getNotification,
  className,
}: BaseCollapsedSectionProps) => (
  <div className={classNames('py-2', className)}>
    <nav className="space-y-1 px-2" aria-label={title || 'Menu section'}>
      {visibleItems.map((item) => (
        <BaseSideMenuItem
          key={item.id}
          item={item}
          isCollapsed={isCollapsed}
          isItemActive={isItemActive}
          renderLink={renderLink}
          hasNotification={getNotification?.(item) ?? false}
        />
      ))}
    </nav>
  </div>
);

export default BaseCollapsedSection;
